import React from 'react';
import { Typography } from '@mui/material';
import AnnouncementIcon from '@mui/icons-material/Announcement';

class Notice extends React.Component {
  render() {
    const { text } = this.props;

    return (
      <div className="notice-container">
        <AnnouncementIcon />
        <Typography component="span" variant="body1" style={{color: '#004085'}}>{text}</Typography>
      </div>
    );
  }
}

export default Notice;
